var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('service-navigation-header',{attrs:{"config":_vm.config,"breadcrumb-items":_vm.breadcrumbItems}},[_c('div',{attrs:{"slot":"account"},slot:"account"},[_c('or-profile-popover',{attrs:{"auth-ui-url":_vm.AUTH_UI_URL}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }